/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetAllDistrictsQueryResult } from '../../models/get-all-districts-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiDistrictGetDistrictsGet$Params {
  MunicipalId?: string;
  SectorId?: string;
  SupervisorId?: string;
  CategoryId?: string;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiDistrictGetDistrictsGet(http: HttpClient, rootUrl: string, params?: ApiDistrictGetDistrictsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllDistrictsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiDistrictGetDistrictsGet.PATH, 'get');
  if (params) {
    rb.query('MunicipalId', params.MunicipalId, {});
    rb.query('SectorId', params.SectorId, {});
    rb.query('SupervisorId', params.SupervisorId, {});
    rb.query('CategoryId', params.CategoryId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllDistrictsQueryResult>;
    })
  );
}

apiDistrictGetDistrictsGet.PATH = '/api/District/GetDistricts';
